<template>
  <div>
    <state-input
      :state="locations"
      :initial-value="state.effect.id"
      :synced-value="state.effect.id"
      :show-label="false"
      width="220px"
      class="location-input"
      :disabled="readonly"
      @input="value => updateLocation(value)"
    >
      <template slot="prefix">At</template>
    </state-input>
    <el-input
      id="assessment-input"
      :value="state.effect.value"
      placeholder="Assessment"
      class="value-input"
      :disabled="readonly"
      @input="assessment => updateAssessment(assessment.trim())"
    >
      <template slot="prepend">To</template>
    </el-input>
  </div>
</template>

<script>
import StateInput from '~lib/common/components/StateInput.vue';

export default {
  name: 'physical-assessment-effect',
  components: {
    StateInput,
  },
  props: ['states', 'readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {
          id: 'HEAD',
          value: '',
        },
      },
    };
  },
  computed: {
    locations() {
      const state = this.states.find(s => s.id === 'physicalAssessmentLocations');
      return state ? {
        ...state,
        possibleValues: state.possibleValues.filter(value => value.key !== 'FULL_BODY')
      } : [];
    }
  },
  mounted() {
    this.state.effect = {
      ...this.state.effect,
      ...(this.getData(this.ikey) || {}),
    };
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updateLocation(locationId) {
      this.state.effect.id = locationId;
      this.update();
    },
    updateAssessment(assessment) {
      this.state.effect.value = assessment;
      this.update();
    },
    update() {
      this.putData(this.ikey, { type: 'PHYSICAL_ASSESSMENT', ...this.state.effect });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
</style>
